import { Models } from "@rematch/core"

import checkout from "./checkout"
import customer from "./customer"
import discounts from "./discounts"
import search from "./search"

export interface RootModel extends Models<RootModel> {
  checkout: typeof checkout
  customer: typeof customer
  discounts: typeof discounts
  search: typeof search
}

export const models: RootModel = { checkout, customer, discounts, search }
